import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

function formatCurrency(value: number | undefined): string {
  if (value === undefined || value === null || Number.isNaN(value)) return "";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

function parseCurrency(s: string): number | undefined {
  const cleaned = s.replace(/[$,]/g, "").trim();
  if (!cleaned) return undefined;
  const n = Number(cleaned);
  return Number.isNaN(n) ? undefined : n;
}

interface CurrencyInputProps {
  value?: number;
  onChange: (value: number | undefined) => void;
  label: string;
  required?: boolean;
  id?: string;
  className?: string;
  disabled?: boolean;
}

export function CurrencyInput({
  value,
  onChange,
  label,
  required,
  id,
  className,
  disabled,
}: CurrencyInputProps) {
  const displayValue = value !== undefined && value !== null ? formatCurrency(value) : "";
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = parseCurrency(e.target.value);
    onChange(v);
  };

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={id}>
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      <Input
        id={id}
        type="text"
        inputMode="decimal"
        placeholder="0.00"
        value={displayValue}
        onChange={handleChange}
        disabled={disabled}
        className="font-mono"
      />
    </div>
  );
}
